"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ElementDefinition_Discriminator = exports.ElementDefinition_DiscriminatorTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var ElementDefinition_DiscriminatorTypeKind;
(function (ElementDefinition_DiscriminatorTypeKind) {
    ElementDefinition_DiscriminatorTypeKind["_value"] = "value";
    ElementDefinition_DiscriminatorTypeKind["_exists"] = "exists";
    ElementDefinition_DiscriminatorTypeKind["_pattern"] = "pattern";
    ElementDefinition_DiscriminatorTypeKind["_type"] = "type";
    ElementDefinition_DiscriminatorTypeKind["_profile"] = "profile";
})(ElementDefinition_DiscriminatorTypeKind = exports.ElementDefinition_DiscriminatorTypeKind || (exports.ElementDefinition_DiscriminatorTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_ElementDefinition_Discriminator = t.recursion('IElementDefinition_Discriminator', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        type: (0, EnumType_1.createEnumType)(ElementDefinition_DiscriminatorTypeKind, 'ElementDefinition_DiscriminatorTypeKind'),
        _type: RTTI_Element_1.RTTI_Element,
        path: t.string,
        _path: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_ElementDefinition_Discriminator.js.map